const errorDialogPlugin = {
  install: (Vue, { store }) => {
    if (!store) {
      throw new Error('Please provide vuex store.');
    }

    Vue.prototype.$errordialog = {
      showMessage: function ({
        content = '',
        title = '',
        color = ''
      }) {
        store.commit(
          'error/showMessage',
          { content, title, color },
          { root: true }
        );
      }
    };
  },
};
export default errorDialogPlugin;